import { onBeforeUnmount, shallowRef, watch, type Ref } from 'vue'

/** The current page's scroll area: the element the router saves, restores and jumps within. */
export const pageScrollElement = shallowRef<HTMLElement | null>(null)

/** Registers an element as the page's scroll area while it is present; it clears only a claim it still holds, so an arriving page keeps its own. */
export function usePageScrollHost(element: Readonly<Ref<HTMLElement | null>>): void {
  watch(
    element,
    (next, previous) => {
      if (previous && pageScrollElement.value === previous) pageScrollElement.value = null
      if (next) pageScrollElement.value = next
    },
    { immediate: true, flush: 'post' },
  )
  onBeforeUnmount(() => {
    if (element.value && pageScrollElement.value === element.value) pageScrollElement.value = null
  })
}
